/**
 * Bridge Strategy — 认证与登录
 *
 * 复用现有认证体系：
 * - isLoggedIn: 同步读 getCookie('user').token
 * - requireLogin: 已登录直接回调，未登录通过 getUserLoginState 弹窗
 */
import type { GetUserLoginStateOptions } from '@/components/RightProvider/context';
import { getCookie } from '@/utils/cookie';

import type { BridgeUserInfo, LandingBridgeMediator } from '../types';

/** 从 cookie 提取用户信息 */
function extractUser(): BridgeUserInfo | null {
  const u = getCookie('user');
  if (!u?.token) return null;
  return {
    uid: u.uid || '',
    email: u.email || '',
    accountId: u.accountId || '',
    token: u.token,
  };
}

/**
 * 注册 Auth Strategy
 * @param bridge Mediator 实例
 * @param getUserLoginState 来自 RightContext 的登录状态检查函数
 */
export function registerAuthStrategy(
  bridge: LandingBridgeMediator,
  getUserLoginState: (options?: GetUserLoginStateOptions) => Promise<boolean>,
): void {
  bridge.register('isLoggedIn', () => {
    return !!getCookie('user')?.token;
  });

  bridge.register('requireLogin', (callback) => {
    // 已登录 → 直接回调
    const user = extractUser();
    if (user) {
      callback?.(user);
      return;
    }

    // 未登录 → 弹窗，登录成功后回调
    getUserLoginState({
      onReady: () => {
        const loggedIn = extractUser();
        if (loggedIn) callback?.(loggedIn);
      },
    });
  });
}
